import React from 'react'

import Rules from '../tabs/data/pages/rules/Rules'
import Descriptions from '../tabs/data/pages/descriptions/Descriptions'

import Source from '@mui/icons-material/Source'
import { RouteConfiguration } from 'routes/nlpRoutes'
import { SettingIcon } from '../uiKit/icons/SettingIcon'

export const dataRoutes: RouteConfiguration[] = [
  {
    path: 'rules',
    name: 'Dataset Rules',
    component: Rules,
    icon: () => <SettingIcon />,
  },
  {
    path: 'descriptions',
    name: 'Descriptions',
    component: Descriptions,
    icon: () => <Source />,
  },
]
